import { compose } from 'ramda';
import { selectors as ghost } from '../state/ghost';
import { currentChapterByPlaytime } from '@/utils/chapters';
import root from './root';

import chapters from './chapters';

const time = compose(
  ghost.time,
  root.ghost,
);
const active = compose(
  ghost.active,
  root.ghost,
);

export default {
  time,
  active,
  chapter: state => currentChapterByPlaytime(chapters.list(state), time(state)),
};
